import { Query } from '../../_base/actionBus/Query';

export class GetRedepagosPayUrl extends Query<string> {}
